<template >
  <Modal v-bind="$attrs" width="1020px" @cancel="$emit('cancel')" @confirm="onConfirm">
    <div style="line-height: 32px" v-loading="audienceLoading" v-if="Object.values(populations).length && rawForm.plan">
      <AudiencesTable v-model="populations" :data="audiencesData" :accounts="[rawForm.plan.account]">
        <el-table-column prop="userCount" width="90" label="覆盖数量"> </el-table-column>
      </AudiencesTable>
    </div>
  </Modal>
</template>
<script>
import { clone } from '@/common/js/just.js'
import Modal from './modal.vue'
import AudiencesTable from '@/views/edit/kuaishou/components/audiences-table/index.vue'
import { getAudience } from '@/api/tencent.model'

export default {
  components: { Modal, AudiencesTable },
  props: {
    currentRow: Object
  },
  data() {
    return {
      pops: {},
      audiencesData: [],
      audienceLoading: false
    }
  },
  computed: {
    populations: {
      get() {
        return this.pops
      },

      set(data) {
        this.pops = {
          [this.rawForm.plan.account.id]: data
        }
      }
    },
    rawForm() {
      return this.currentRow || {}
    }
  },
  watch: {
    '$attrs.visible'(v) {
      if (v) {
        const { plan, target } = this.rawForm
        const accountId = plan.account.id
        this.getAudienceData(accountId)
        // 构造人群包数据结构
        this.pops = {
          [accountId]: clone(target.populations[accountId])
        }
      }
    }
  },
  methods: {
    onConfirm() {
      const newForm = this.rawForm
      const accountId = newForm.plan.account.id
      newForm.target.populations[accountId] = this.pops[accountId]
      this.$emit('confirm', newForm.target.populations)
    },
    getAudienceData(ad_account_id) {
      if (!ad_account_id) return
      this.audienceLoading = true
      getAudience({ ad_account_id }).then((data) => {
        this.audiencesData = data.map((au) => ({
          ...au,
          check: null,
          includesDisabled: false,
          excludesDisabled: false,
          groupId: au.audience_id,
          groupName: au.name,
          userCount: au.user_count
        }))
        this.audienceLoading = false
      })
    }
  }
}
</script>
